<template>
  <div class="navbar">
    <nav class="navbar navbar-default" role="navigation">
      <div class="container-fluid">
        <div class="navbar-header">
          <a class="navbar-brand" href="javascript:void(0);" target="_blank">
            <img :src="logo" style="position: relative; top: -7px" alt />
          </a>
        </div>
        <div>
          <ul class="nav navbar-nav center-block">
            <li
              class="dropdown"
              v-for="(item, index) in $store.state.sideMenu"
              :key="index"
            >
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-toggle="dropdown"
              >
                {{ $t("mine.nav." + item.routername) }}
                <b class="caret"></b>
              </a>
              <ul class="dropdown-menu" style="left: 0">
                <li v-for="(i, n) in item.items" :key="n">
                  <a href="javascript:void(0);" @click="goToByName(i)">
                    <img
                      :src="'../assets/menu_icon/' + i.routername + '.png'"
                      alt
                      width="15px"
                      class="menu_icon"
                    />
                    {{ $t("mine.sideMenu." + i.routername) }}
                  </a>
                </li>
              </ul>
            </li>

            <li class="dropdown" v-if="$store.state.isLogin">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle"
                data-toggle="dropdown"
              >
                {{ $t("footer.mine") }}
                <b class="caret"></b>
              </a>
              <ul class="dropdown-menu" style="left: 0">
                <li class="" v-show="$store.state.commonInfo.rid == 1">
                  <a href="javascript:void(0);" @click="goTo('/SubAccount')">
                    <img
                      src="../assets/menu_icon/19grxx.png"
                      alt
                      width="15px"
                      class="menu_icon"
                    />
                    {{ $t("mine.sideMenu.SubAccount") }}
                  </a>
                </li>

                 <li class="">
                  <a href="javascript:void(0);" @click="goTo('/Chat')">
                    <img
                      src="../assets/menu_icon/SettingRole.png"
                      alt
                      width="15px"
                      class="menu_icon"
                    />
                    {{ $t("在线咨询") }}
                  </a>
                </li>

                <li class="hidden">
                  <a href="javascript:void(0);" @click="goTo('/SettingNotice')">
                    <img
                      src="../assets/menu_icon/SettingRank.png"
                      alt
                      width="15px"
                      class="menu_icon"
                    />
                    {{ $t("公告管理") }}
                  </a>
                </li>


                <li>
                  <a
                    href="javascript:void(0);"
                    @click="goTo('/Profile/' + $store.state.commonInfo.uid)"
                  >
                    <img
                      src="../assets/menu_icon/19grxx.png"
                      alt
                      width="15px"
                      class="menu_icon"
                    />
                    {{ $t("mine.sideMenu.Profile") }}
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" @click="goTo('/pwdChange')">
                    <img
                      src="../assets/menu_icon/20xgmm.png"
                      alt
                      width="15px"
                      class="menu_icon"
                    />
                    {{ $t("mine.sideMenu.pwdChange") }}
                  </a>
                </li>
                 <li>
                  <a href="javascript:void(0);" @click="download()">
                    <img
                      src="../assets/menu_icon/20xgmm.png"
                      alt
                      width="15px"
                      class="menu_icon"
                    />
                    {{ $t("下载客户端") }}
                  </a>
                </li>
                <li>
                  <a href="javascript:void(0);" @click="logout">
                    <img
                      src="../assets/menu_icon/21tczh.png"
                      alt
                      width="15px"
                      class="menu_icon"
                    />
                    {{ $t("mine.sideMenu.logout") }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>

          <span
            v-if="$store.state.isLogin"
            @click="goToChat()"
            class="pull-right text-primary"
            style="
              padding: 15px;
              position: absolute;
              right: 90px;
              cursor: pointer;
            "
          >
            <i class="fa fa-bell" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      overFlag: false,
      logo: "",
      newMsgNum: 0,
      getMsgInterval: null,
    };
  },
  mounted: function () {
    var that = this;

    if (that.getMsgInterval) {
      that.getMsgInterval = null;
    }

    that.stopDataIntervalFlag = false;
    setTimeout(function () {
      that.stopDataIntervalFlag = false;
    }, 1000 * 10);

    this.getUnread();
    this.getMsgInterval = setInterval(function () {
      that.getUnread();
    }, 1000 * 60 * 1);
  },
  destroyed() {
    clearInterval(this.getMsgInterval);
  },
  computed: {
    chatUrl: function () {
      return myutil.chat_url + "/?token=" + this.$store.state.token;
      if (window.location.host.search("80") != -1) {
        // 本地开发
        return "http://192.168.1.8:8091/?token=" + this.$store.state.token;
      } else {
        return "https://chat.firstffc.com/?token=" + this.$store.state.token;
      }
    },
  },
  methods: {
    download: function(){
      this.$router.push({ name: 'DownloadApp' });
      return
      var a  = myutil.appSourceUrl + '?short=' + myutil.shortName +'&version=' + this.$store.state.ver;
      console.log(a);
      window.open(a,'_blank');
    },
    getUnread: function () {
      var that = this;
      if (!that.$store.state.isLogin) {
        return;
      }
      if (myutil.pcFlag) {
        // pc才可以
        return;
      }
      if (that.stopDataIntervalFlag) {
        console.log("请求太频繁");
        return;
      }
      that.stopDataIntervalFlag = true;

      setTimeout(function () {
        var _url = myutil.base_url + "/user/chat_unread_count";

        $.get({
          url: _url,
          success: function (res, status, xhr) {
            if (xhr.status == 200) {
              that.stopDataIntervalFlag = false;
            }
            that.newMsgNum = Number(res);
          },
          error: function (result) {
            that.stopDataIntervalFlag = true;
          },
        });
      }, 1000 * 5);
    },
    goToChat: function () {
      if (myutil.hasOwnProperty("thirdChatUrl")) {
        this.$router.push({
          path: "/Chat2",
        });
      } else {
        this.$router.push({
          path: "/Chat",
          query: {
            token: this.$store.state.token,
          },
        });
      }
    },
    goTo: function (_path) {
      this.$router.push({
        path: _path,
      });
    },
    logout: function () {
      var that = this;
      var _url = myutil.base_url + "/user/logout";
      $.get(_url).done(function (res) {
        that.$store.commit("set_isLogin", "");
        that.$store.commit("set_token", "");

        that.$store.commit("set_sideMenu", []);
        that.$store.commit("set_subMenu", []);
        that.$store.commit("set_orderMenu", []);
        that.$store.commit("set_recordPositionMenu", []);

        that.$store.commit("set_userInfo", "");
        that.$store.commit("set_commonInfo", "");
        that.$store.commit("set_langOnPage", {
          IntroMarket: "en", // 首页
          other: "zh",
        });

        $.ajaxSetup({
          headers: {
            Authorization: that.$store.state.token,
          },
        });

        // document.querySelector(".home").click();
        that.$router.push("/");

        // window.location.replace(window.location.origin);
      });
    },
    goToByName: function (i) {
      this.$router.push({ name: i.routername });
      myutil.setBanner(this, i.name);
    },
  },
};
</script>

<style lang="less" scoped>
.i18n {
  position: absolute;
  top: 80px;
  color: #fff;
  right: 20px;
  cursor: pointer;
}
.navbar {
  height: 35px;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 99;
  p {
    color: #fff;
    font-weight: bold;
    line-height: 35px;
    font-size: 110%;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/Navbar.vue